import { render, staticRenderFns } from "./index.vue?vue&type=template&id=130c47a4"
import script from "./defaultData.js?vue&type=script&lang=js&external"
export * from "./defaultData.js?vue&type=script&lang=js&external"
import style0 from "./defaultData.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports